export default __webpack_public_path__ + "static/media/bars.bfa3718d.svg";